import { __awaiter, __generator, __read, __values } from "tslib";
import { writeAll } from '@office-start/idb-cache';
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { storeName } from './Constants';
import { getDbAndKeyTuple } from './getDbAndKeyTuple';
export function writeToSimplePersistence(_a) {
    var _b, _c;
    var userId = _a.userId, collectionName = _a.collectionName, collectionVersion = _a.collectionVersion, key = _a.key, data = _a.data, hashKey = _a.hashKey, _d = _a.plugins, plugins = _d === void 0 ? [] : _d, _e = _a.writeBehavior, writeBehavior = _e === void 0 ? 'replace' : _e;
    return __awaiter(this, void 0, void 0, function () {
        var _f, db, currentKey, plugins_1, plugins_1_1, plugin, e_1_1, e_2;
        var e_1, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 10, , 11]);
                    return [4 /*yield*/, getDbAndKeyTuple(userId, collectionName, collectionVersion, key, hashKey)];
                case 1:
                    _f = __read.apply(void 0, [_j.sent(), 2]), db = _f[0], currentKey = _f[1];
                    _j.label = 2;
                case 2:
                    _j.trys.push([2, 7, 8, 9]);
                    plugins_1 = __values(plugins), plugins_1_1 = plugins_1.next();
                    _j.label = 3;
                case 3:
                    if (!!plugins_1_1.done) return [3 /*break*/, 6];
                    plugin = plugins_1_1.value;
                    if (!plugin.onBeforeWriteValue) return [3 /*break*/, 5];
                    return [4 /*yield*/, plugin.onBeforeWriteValue(data, currentKey, {
                            userId: userId,
                            collectionName: collectionName,
                            collectionVersion: collectionVersion,
                        })];
                case 4:
                    data = _j.sent();
                    _j.label = 5;
                case 5:
                    plugins_1_1 = plugins_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _j.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (plugins_1_1 && !plugins_1_1.done && (_g = plugins_1.return)) _g.call(plugins_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    // Don't persist `null` or `undefined` data to storage.
                    if (!data) {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, writeAll(db, [data], storeName, writeBehavior, [currentKey])];
                case 10:
                    e_2 = _j.sent();
                    logErrorEvent(KnownInstrumentationEvents.SimplePersistenceWriteError, (_h = {},
                        _h["Error" /* InstrumentationParam.Error */] = "Error writing to ".concat(collectionName, ": ").concat((_b = e_2 === null || e_2 === void 0 ? void 0 : e_2.toString) === null || _b === void 0 ? void 0 : _b.call(e_2)),
                        _h));
                    logError({
                        eventName: 'Simple_Persistence_Write_Error',
                        errorType: 'SimplePersistence_Error',
                        message: "Error writing to ".concat(collectionName, ": ").concat((_c = e_2 === null || e_2 === void 0 ? void 0 : e_2.toString) === null || _c === void 0 ? void 0 : _c.call(e_2)),
                    });
                    throw e_2;
                case 11: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=writeToSimplePersistence.js.map